import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Süresi dolmuş token'ı otomatik algıla ve kullanıcıyı çıkış yaptır
const _originalFetch = window.fetch;
window.fetch = async function (...args) {
    const response = await _originalFetch.apply(this, args);
    if (response.status === 401) {
        try {
            const data = await response.clone().json();
            if (data.token_expired === true || data.hata === 'Token süresi dolmuş!') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('userToken');
                window.location.replace('/login');
            }
        } catch (_) {}
    }
    return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
